import {IAnalyticsEvent} from 'coreClasses/analytics/IAnalytics';
import {EEventType, IEventData} from 'coreClasses/events/IEvents';

import AddToWishlistEvent from './events/AddToWishlistEvent';
import AddToCartEvent from './events/AddToCartEvent';
import PageViewEvent from './events/PageViewEvent';
import RemoveFromCartEvent from './events/RemoveFromCartEvent';
import SelectItemEvent from './events/SelectItemEvent';
import ViewItemEvent from './events/ViewItemEvent';
import ViewItemListEvent from './events/ViewItemListEvent';
import ViewPromotionEvent from './events/ViewPromotionEvent';
import SelectPromotionEvent from './events/SelectPromotionEvent';
import SignupEvent from './events/SignupEvent';
import NewsletterSubcriptionEvent from './events/NewsletterSubscriptionEventModel';
import CartUpdatedEvent from './events/CartUpdatedEvent';
import WishlistUpdatedEvent from './events/WishlistUpdatedEvent';

/**
 * Represents AnalyticsEventsFactory
 */
class AnalyticsEventsFactory {
	/**
	 * Creates event
	 * @param {EEventType} eventType - event type
	 * @param {IEventData} eventData - event data
	 * @returns {IAnalyticsEvent | null} - event
	 */
	static create(eventType: EEventType, eventData: IEventData): IAnalyticsEvent | null {
		let event: IAnalyticsEvent = null;

		switch (eventType) {
			case EEventType.PAGE_VIEW:
				event = {...new PageViewEvent(eventData)};

				break;
			case EEventType.PRODUCT_ADD_TO_WISHLIST:
				event = {...new AddToWishlistEvent(eventData)};

				break;
			case EEventType.PRODUCT_ADD_TO_CART:
				event = {...new AddToCartEvent(eventData)};

				break;
			case EEventType.CART_UPDATED:
				event = {...new CartUpdatedEvent(eventData)};

				break;
			case EEventType.WISHLIST_UPDATED:
				event = {...new WishlistUpdatedEvent(eventData)};

				break;
			case EEventType.PRODUCT_CLICK:
				event = {...new SelectItemEvent(eventData)};

				break;
			case EEventType.PRODUCT_REMOVE_FROM_CART:
				event = {...new RemoveFromCartEvent(eventData)};

				break;
			case EEventType.PRODUCT_DETAIL_VIEW:
				event = {...new ViewItemEvent(eventData)};

				break;
			case EEventType.VIEW_ITEM_LIST:
				event = {...new ViewItemListEvent(eventData)};

				break;
			case EEventType.VIEW_BRAND_PROMOTION:
				event = {...new ViewPromotionEvent(eventData)};

				break;
			case EEventType.SELECT_BRAND_PROMOTION:
				event = {...new SelectPromotionEvent(eventData)};

				break;
			case EEventType.LOGS_IN:
			case EEventType.LOGS_OUT:
			case EEventType.SIGNUP:
				event = {...new SignupEvent(eventData, eventType)};

				break;
			case EEventType.NEWSLETTER_SUBSCRIPTION:
				event = {...new NewsletterSubcriptionEvent(eventData)};

				break;
			default:
				break;
		}

		return event;
	}
}

export default AnalyticsEventsFactory;
